<template>
  <div id="fountertestAnchor" ref="fountertestAnchor"></div>
  <form @submit.prevent="onSubmit" v-if="readyState">
    <fieldset v-if="!userSelections.progress.founderstartquestionsReady">
      <template v-for="(founderteststartquestion, index) in founderteststartquestions"
                :key="founderteststartquestion['Id']">
        <div class="question-wrap" v-if="userSelections.progress.founderteststartquestionsCurrent === index">
          <template
              v-if="userSelections.progress.founderteststartquestionsCurrent === 0 && !userSelections.startanswersAccepted">
            <div class="container entry-header">
              <h1 class="headline headline--1">Viel Spaß beim Gründertest.</h1>
              <div class="question">
                <span>Zu Beginn gibt es einige Fragen zu deiner Gründungssituation, um dir am Ende individuelle Tipps für deinen Start zu geben. </span>
                <div class="author">
                  <figure>
                    <img src="@/assets/rene-klein.jpg"/>
                  </figure>
                </div>
              </div>

              <button class="btn btn--big next" @click="acceptAction('startanswersAccepted')">
                <span class="label">weiter</span>
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18">
                    <path
                        fill="currentColor"
                        d="M31,9a1.3,1.3,0,0,0-.4-1L22.8.4a1.1,1.1,0,0,0-.9-.4,1.3,1.3,0,0,0-1,.4,1.1,1.1,0,0,0-.4.9V6.6H.7l-.5.2a.8.8,0,0,0-.2.5v3.4a.8.8,0,0,0,.2.5l.5.2H20.5v5.3a1.1,1.1,0,0,0,.4.9,1.3,1.3,0,0,0,1,.4,1.1,1.1,0,0,0,.9-.4L30.6,10A1.3,1.3,0,0,0,31,9Z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </template>
          <Question
              v-if="userSelections.startanswersAccepted"
              :state-is="userSelections.progress.founderteststartquestions"
              :state-max="founderteststartquestions.length"
              :question="founderteststartquestion"
              :answers="idFilter(founderteststartquestion['Id'], 'questionid', founderteststartanswers)"
              :send-answers="receiveQuestion"
              cluster="Gründungssituation"
              answers-type="founderteststartanswers"
              :q-index="index"
              :user-selections="userAnswer('founderteststartanswers', founderteststartquestion['Id'])"
          />
          <div class="container prevBtn">
            <div class="row">
              <button
                  class="btn btn--big prev"
                  @click="previousQuestion('founderteststartquestions')"
                  v-if="showPreviousButton('founderteststartquestions') && userSelections.progress.founderteststartquestionsCurrent === index"
              >
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18">
                    <path
                        fill="currentColor"
                        d="M-1.4,9A1.3,1.3,0,0,0-1,10l7.7,7.6a1.3,1.3,0,0,0,1,.4,1.3,1.3,0,0,0,1-.4,1.5,1.5,0,0,0,.4-.9V11.4H28.9l.5-.2a.8.8,0,0,0,.2-.5V7.3a.8.8,0,0,0-.2-.5l-.5-.2H9.1V1.3A1.5,1.5,0,0,0,8.7.4a1.3,1.3,0,0,0-1-.4,1.3,1.3,0,0,0-1,.4L-1,8A1.3,1.3,0,0,0-1.4,9Z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </fieldset>
    <fieldset
        v-if="userSelections.progress.founderstartquestionsReady && !userSelections.progress.foundertestquestionsReady">
      <template v-for="(foundertestquestion, index) in foundertestquestions" :key="foundertestquestion['Id']">
        <div class="question-wrap" v-if="userSelections.progress.foundertestquestionsCurrent === index">
          <template v-if="userSelections.progress.foundertestquestionsCurrent === 0 && !userSelections.answersAccepted">
            <div class="container entry-header">
              <div class="question">
                <span>
                  Sehr gut.<br/>Nun geht es mit Fragen weiter, die sowohl Aspekte der Persönlichkeit als auch fachliche Voraussetzungen erfolgreicher
                  Unternehmer beleuchten.
                </span>
                <div class="author">
                  <figure>
                    <img src="@/assets/rene-klein.jpg"/>
                  </figure>
                </div>
              </div>
              <button class="btn btn--big next" @click="acceptAction('answersAccepted')">
                <span class="label">weiter</span>
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18">
                    <path
                        fill="currentColor"
                        d="M31,9a1.3,1.3,0,0,0-.4-1L22.8.4a1.1,1.1,0,0,0-.9-.4,1.3,1.3,0,0,0-1,.4,1.1,1.1,0,0,0-.4.9V6.6H.7l-.5.2a.8.8,0,0,0-.2.5v3.4a.8.8,0,0,0,.2.5l.5.2H20.5v5.3a1.1,1.1,0,0,0,.4.9,1.3,1.3,0,0,0,1,.4,1.1,1.1,0,0,0,.9-.4L30.6,10A1.3,1.3,0,0,0,31,9Z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </template>
          <Question
              v-if="userSelections.answersAccepted"
              :state-is="userSelections.progress.foundertestquestions"
              :state-max="foundertestquestions.length"
              :question="foundertestquestion"
              :answers="idFilter(foundertestquestion['Id'], 'questionid', foundertestanswer)"
              :send-answers="receiveQuestion"
              answers-type="foundertestanswer"
              :randomize="true"
              :q-index="index"
              :cluster="getCluster(foundertestquestion['clusterid'])"
              :user-selections="userAnswer('foundertestanswer', foundertestquestion['Id'])"
          />
          <div class="container prevBtn">
            <div class="row">
              <button
                  class="btn btn--big prev"
                  @click="previousQuestion('foundertestquestions')"
                  v-if="showPreviousButton('foundertestquestions') && userSelections.progress.foundertestquestionsCurrent === index"
              >
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18">
                    <path
                        fill="currentColor"
                        d="M-1.4,9A1.3,1.3,0,0,0-1,10l7.7,7.6a1.3,1.3,0,0,0,1,.4,1.3,1.3,0,0,0,1-.4,1.5,1.5,0,0,0,.4-.9V11.4H28.9l.5-.2a.8.8,0,0,0,.2-.5V7.3a.8.8,0,0,0-.2-.5l-.5-.2H9.1V1.3A1.5,1.5,0,0,0,8.7.4a1.3,1.3,0,0,0-1-.4,1.3,1.3,0,0,0-1,.4L-1,8A1.3,1.3,0,0,0-1.4,9Z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </fieldset>
  </form>
  <Results :user-selections="userSelections" :foundertestclusters="this.foundertestclusters"
           v-if="userSelections.progress.foundertestquestionsReady"/>
  <div
      class="reset"
      v-if="
      userSelections.startanswersAccepted &&
      !userSelections.answersAccepted &&
      Object.keys(userSelections.founderteststartanswers).length < founderteststartquestions.length
    "
  >
    <div class="container">
      <button class="btn restart" @click="resetApp">
        <span class="icon"
        ><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
            <path
                d="M34.1,13.2a.8.8,0,0,0-1.1-.3l-3.2,1.9a.8.8,0,0,0-.3,1.1A10.1,10.1,0,0,1,13.3,27.6a9.9,9.9,0,0,1-2.9-7.1,10.3,10.3,0,0,1,2.9-7.2,10.3,10.3,0,0,1,7.2-2.9v3.4a.9.9,0,0,0,1.4.8L33,8.2a.9.9,0,0,0,0-1.6L21.9.2a.9.9,0,0,0-1.4.8V5.1A15.4,15.4,0,1,0,35.9,20.5,15.2,15.2,0,0,0,34.1,13.2Z"
            />
          </svg>
        </span>
        <span class="label">Gründertest neu starten</span>
      </button>
    </div>
  </div>
  <div class="reset" v-if="userSelections.startanswersAccepted && userSelections.answersAccepted">
    <div class="container">
      <button class="btn restart" @click="resetApp">
        <span class="icon"
        ><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
            <path
                d="M34.1,13.2a.8.8,0,0,0-1.1-.3l-3.2,1.9a.8.8,0,0,0-.3,1.1A10.1,10.1,0,0,1,13.3,27.6a9.9,9.9,0,0,1-2.9-7.1,10.3,10.3,0,0,1,2.9-7.2,10.3,10.3,0,0,1,7.2-2.9v3.4a.9.9,0,0,0,1.4.8L33,8.2a.9.9,0,0,0,0-1.6L21.9.2a.9.9,0,0,0-1.4.8V5.1A15.4,15.4,0,1,0,35.9,20.5,15.2,15.2,0,0,0,34.1,13.2Z"
            />
          </svg>
        </span>
        <span class="label">Gründertest neu starten</span>
      </button>
    </div>
  </div>
  <div class="loader hidden" ref="loader">
    <div class="preloader">
      <span>
        <svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="45"></circle>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
window.onload = function () {
  const header = document.querySelector("header");
  const footer = document.querySelector("footer");
  let headerHeight = 0;
  let footerHeight = 0;
  if (header) {
    headerHeight = header.getBoundingClientRect().height;
  }
  if (footer) {
    footerHeight = footer.getBoundingClientRect().height;
  }
  document.documentElement.style.setProperty("--hfHeight", headerHeight + footerHeight + "px");
};

import jsonata from "jsonata";
import Data from "../assets/gruendertest.json";
import Question from "./Question";
import Results from "./Results";

export default {
  name: "Dashboard",
  components: {Results, Question},
  data() {
    return {
      readyState: false,
      dataBase: [],
      founderteststartquestions: [],
      founderteststartanswers: [],
      foundertestquestions: [],
      foundertestanswer: [],
      foundertestclusters: [],
      userSelections: {
        startanswersAccepted: false,
        answersAccepted: false,
        founderteststartanswers: {},
        foundertestanswer: {},
        progress: {
          founderteststartquestions: 0,
          foundertestquestions: 0,
          founderstartquestionsReady: false,
          foundertestquestionsReady: false,
          founderteststartquestionsCurrent: 0,
          foundertestquestionsCurrent: 0,
        },
        clusterScore: {},
      },
    };
  },
  mounted() {
    this.showLoader();
    document.body.classList.add("foundertest");
    if (localStorage.p4bfoundertest) {
      this.userSelections = JSON.parse(localStorage.p4bfoundertest);
    }
    this.dataBase = Data;
    this.founderteststartquestions = Data[6].data;
    this.founderteststartanswers = Data[5].data;
    this.foundertestquestions = Data[4].data;
    this.foundertestclusters = Data[3].data;
    this.foundertestanswer = Data[2].data;
    this.arraySort(this.foundertestquestions, "order");
    this.progressStatus();
    this.readyState = true;
  },
  methods: {
    resetApp() {
      this.userSelections = {
        startanswersAccepted: false,
        answersAccepted: false,
        founderteststartanswers: {},
        foundertestanswer: {},
        progress: {
          founderteststartquestions: 0,
          foundertestquestions: 0,
          founderstartquestionsReady: false,
          foundertestquestionsReady: false,
          founderteststartquestionsCurrent: 0,
          foundertestquestionsCurrent: 0,
        },
        clusterScore: {},
      };
      localStorage.p4bfoundertest = JSON.stringify(this.userSelections);
    },
    clusterSorting() {
      for (const cluster of this.foundertestclusters) {
        Object.assign(
            this.userSelections.clusterScore,
            new Object({
              [cluster["Id"]]: new Object({
                name: cluster["name"],
                score: 0,
                questions: 0,
                clusterId: cluster["Id"],
                resultAverage: cluster["resultAverage"],
                resultBad: cluster["resultBad"],
                resultGood: cluster["resultGood"],
              }),
            })
        );
      }
      for (const [i, answer] of Object.entries(this.userSelections.foundertestanswer)) {
        if (i < 0) {
          console.log(i);
        }
        const clusterID = answer["clusterid"];
        this.userSelections.clusterScore[clusterID].score = 0 + this.userSelections.clusterScore[clusterID].score + parseInt(answer.value);
        this.userSelections.clusterScore[clusterID].questions++;
      }
    },
    progressStatus() {
      localStorage.p4bfoundertest = JSON.stringify(this.userSelections);
      this.userSelections.progress.founderteststartquestions = Object.keys(this.userSelections.founderteststartanswers).length;
      this.userSelections.progress.foundertestquestions = Object.keys(this.userSelections.foundertestanswer).length;
      this.userSelections.progress.founderteststartquestions < this.founderteststartquestions.length
          ? (this.userSelections.progress.founderstartquestionsReady = false)
          : (this.userSelections.progress.founderstartquestionsReady = true);
      this.userSelections.progress.foundertestquestions < this.foundertestquestions.length
          ? (this.userSelections.progress.foundertestquestionsReady = false)
          : (this.userSelections.progress.foundertestquestionsReady = true);
      this.clusterSorting();
    },
    acceptAction(type) {
      this.showLoader();
      this.userSelections[type] = true;
      localStorage.p4bfoundertest = JSON.stringify(this.userSelections);
    },
    userAnswer(type, id) {
      if (this.userSelections[type][id]) {
        return this.userSelections[type][id];
      }
    },
    getCluster(id) {
      const cluster = jsonata(`*[Id='${id}']`).evaluate(this.foundertestclusters);
      return cluster["name"];
    },
    previousQuestion(type) {
      this.userSelections.progress[type + "Current"] >= 1 ? this.userSelections.progress[type + "Current"]-- : null;
    },
    showPreviousButton(type) {
      return this.userSelections.progress[type + "Current"] >= 1;
    },
    nextQuestion(type) {
      this[type].length - 1 > this.userSelections.progress[type + "Current"] ? this.userSelections.progress[type + "Current"]++ : null;
      return this[type].length - 1 > this.userSelections.progress[type + "Current"];
    },
    receiveQuestion(question, type, clusterid) {
      this.showLoader();
      if (clusterid) {
        Object.assign(question, new Object({clusterid: clusterid}));
      }
      Object.assign(this.userSelections[type], new Object({[question["questionid"]]: question}));
      if (type === "founderteststartanswers") {
        this.nextQuestion("founderteststartquestions");
      }
      if (type === "foundertestanswer") {
        this.nextQuestion("foundertestquestions");
      }
      this.progressStatus();
      this.goto("fountertestAnchor");
    },
    onSubmit() {
    },
    goto(refName) {
      const element = this.$refs[refName];
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    idFilter(id, key, array) {
      let filteredItems = [];
      filteredItems = [...array.filter((a) => a["questionid"] === id)];
      return filteredItems;
    },
    arraySort(array, sortfield) {
      array.sort((a, b) => {
        return parseInt(a[sortfield]) < parseInt(b[sortfield]) ? -1 : 1;
      });
      return array;
    },
    showLoader() {
      this.$refs.loader.classList.remove("hidden");
      document.body.classList.add("loading");
      setTimeout(() => {
        this.$refs.loader.classList.add("hidden");
        document.body.classList.remove("loading");
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
/* fieldset {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  grid-auto-flow: column;
  gap: 0;
  .question-wrap {
    padding: 12em 0;
    grid-column-start: 1;
    grid-row-start: 1;
    width: 100%;
    grid-column-end: 1;
    grid-row-end: 1;
  }
} */
.slide-fade-enter-active {
  transition: all 0.6s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.6s ease-in;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(10vh);
}

.slide-fade-leave-to {
  opacity: 0;
}
</style>
